import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let MapLoading = class MapLoading extends Vue {
    progress;
};
__decorate([
    Prop({ default: 0, type: Number })
], MapLoading.prototype, "progress", void 0);
MapLoading = __decorate([
    Component({
        name: 'MapLoading',
        components: {},
        i18n: {
            messages: {
                zh: {},
                en: {},
            }
        }
    })
], MapLoading);
export default MapLoading;
